import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-favarite",
  "use": "icon-favarite-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-favarite\"><defs><style type=\"text/css\"></style></defs><path d=\"M512.48 165.92c107.04-107.04 279.84-107.04 386.88 0 106.56 106.56 106.56 279.84 0 386.4L512.48 939.2l-386.88-386.88-0.96-0.96C18.08 444.8 18.08 271.52 124.64 164.96c107.04-107.04 279.84-107.04 386.88 0 0.48 0 0.48 0.48 0.96 0.96\" p-id=\"1680\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol